export default function PrimaryButton({
  loading,
  onClick,
  btnText,
  Icon,
  isDisabled,
  textSize,
  size,
}) {
  return (
    <button
      className={`bg-button-bg text-white px-3 py-[6px] hover:bg-hover-bg transition ease-in-out duration-700 
          ${
            isDisabled || loading
              ? "cursor-not-allowed pointer-events-none"
              : ""
          } 
           rounded-lg flex-center-align`}
      onClick={onClick}
      type="submit"
      disabled={isDisabled || loading}
    >
      {Icon && <Icon size={size} className="mr-1" />}
      <span className={`${textSize ? textSize : "text-lg max-lg:text-sm"}`}>
        {btnText}
      </span>
    </button>
  );
}
